import React from "react";
import { Card, CardBody, Form, FormGroup } from "reactstrap";
import HeaderCard from "../../../../Shared/Components/HeaderCard";

import AsesorsSelector from "./AsesorsSelector";

export default function Asesors({ register, errors, reset, setValue }) {
  return (
    <>
      <Card>
        <HeaderCard
          title="Asesores"
          span1="Selecciona los asesores que deseas agregar"
        />
        <CardBody>
          <div id="remote">
            <Form className="theme-form">
              <FormGroup>
                <AsesorsSelector
                  register={register}
                  errors={errors}
                  reset={reset}
                  setValue={setValue}
                />
              </FormGroup>
            </Form>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
